export default __webpack_public_path__ + "static/media/6.342a4cb5.png";